<template>
	<div>
		<event-list :issearch="false" :start="start" :end="end"></event-list>
	</div>
</template>

<script>

import EventList from './List.vue'

export default {
	components: {
		EventList
	},
	data () {
		return {
			start: 0,
			end: 0
		}
	},
	mounted() {
		this.start = this.$route.query.start;
		this.end = this.$route.query.end;
	}
}
</script>